export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8403.2b6b0338.jpg";